import { Countries } from 'shared/enums';
import { postData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGN, CAMPAIGNv3 } from './mediaPlanning';
import { CountryFormState, DdxState } from '../../../store/planStore';

export interface SavePlanResponseData {
  id: string;
}

export interface SavePlanBody {
  campaignName: string;
  campaignCode: string;
  division: string;
  brand: string;
  category: string;
  ddx?: DdxState;
  countrySetup: Record<string, Partial<CountryFormState>>;
}
export const savePlan = async ({
  body,
}: {
  body: SavePlanBody;
  countryISO?: Countries;
}) => {
  return postData<ApiResponse<SavePlanResponseData>>(
    `/${CAMPAIGNv3}/media-plans`,
    body
  );
};
